import { createElement } from 'react';
import { RouteObject, redirect } from 'react-router-dom';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';
import { pathKeys } from 'shared/lib/react-router';

import ProjectCreatePage from './ProjectCreatePage';

export const projectCreatePageRoute: RouteObject = {
  path: 'create/',
  element: createElement(ProjectCreatePage),
  loader: async (args) => {
    const requiredPermissions = replacePermissions(pathPermissions.project.create, args.params);
    if (!isHasAccess(requiredPermissions)) {
      return redirect(pathKeys.dashboard());
    }

    if (!args.params.accountId) {
      return redirect(pathKeys.page404());
    }

    return args;
  },
};
